import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { LayoutService } from 'src/app/services/layout.service';
import { ICustomMenuItem, IMenuItemParameters, ISubmenuComponent } from 'src/app/services/menu/menu.models';
import { LazyLoaderBaseComponent } from '../lazy-loader/lazy-loader.component';
import { LazyLoaderService } from '../lazy-loader/lazy-loader.service';

/**
 * Menu Item Component
 * Available options:
 * menuItem.iconTemplate: TemplateRef<any>
 * menuItem.badgeTemplate: TemplateRef<any>
 */
@Component({
    selector: 'app-menu-item,[app-menu-item]',
    templateUrl: './app.menu-item.component.html',
    styleUrls: ['./app.menu-item.component.scss'],
})
export class AppMenuItemComponent extends LazyLoaderBaseComponent {

    @HostBinding('attr.disabled') get disabled() {
        return this.menuItem?.disabled;
    }

    @Input() parameters: IMenuItemParameters;
    get menuItem(): ICustomMenuItem {
        return this.parameters?.menuItem;
    }


    get index(): number {
        return this.parameters?.index;
    }

    get parentComponent(): ISubmenuComponent {
        return this.parameters?.parentComponent;
    }


    currentLayout$ = this.layoutService.currentLayout$.asObservable();

    constructor(
        public layoutService: LayoutService,
        lazyLoaderService: LazyLoaderService,
    ) {
        super(lazyLoaderService)
    }

    itemClick(event: Event) {
        if(this.menuItem.disabled) return;

        this.parameters?.parentComponent.itemClick(event, this.menuItem, this.index);
    }

    onMouseEnter($event?: Event) {
        this.parameters?.parentComponent.onMouseEnter(this.index);
    }

    async isActive(): Promise<boolean> {
        return this.parameters?.parentComponent.activeIndex === this.index;
    }

}

function Outout(target: AppMenuItemComponent, propertyKey: 'index', descriptor: TypedPropertyDescriptor<number>): void | TypedPropertyDescriptor<number> {
    throw new Error('Function not implemented.');
}
